export const formatCurrency = (number: number, currency: string, options?: Intl.NumberFormatOptions) => {
    // If there is a whole number, don't show any decimal places
    // otherwise, show 2 decimal places
    const roundedTwoDpNumber = Math.round(number * 100) / 100;
    const minimumFractionDigits = Math.floor(roundedTwoDpNumber) === roundedTwoDpNumber ? 0 : 2;

    // changed undefined locale to 'en-US' as we need prices format to show constantly across different users' browser locales
    // Check discussion here https://lokalise.atlassian.net/browse/CC-688?focusedCommentId=35768
    return number.toLocaleString('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits,
        maximumFractionDigits: 2,
        ...options,
    });
};

export default formatCurrency;
